import { h, Component } from 'preact'

import { connect } from 'app/store'
import Button from 'app/components/Button'
import { route, Link } from 'preact-router'
import screenshot from '../assets/screenshot.png'

const ctaButton = {
  height: '2.4em',
  fontSize: '1.4em',
  minWidth: '280px',
}

const headlineStyle = {
  lineHeight: '28px',
  maxWidth: '600px',
}

class Landing extends Component {
  state = {}

  render() {
    return (
      <div>
        <section id="cta" class=" mt- -5">
          <div class="row">
            <div class="col text-center">
              {/* <h2>Bookmarking, plain and simple.</h2> */}
              <h2>Minimalistic bookmarking</h2>
              <h5 style={headlineStyle} class="text-muted my-3 font-weight-normal mx-auto">
                Manter is a bookmarking tool for people who value speed, simplicity and control over
                their data.
                {/* Manter is a simple, fast, privacy friendly tracking tool. */}
              </h5>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col text-center">
              <Button style={ctaButton} class="d-block m-auto" onClick={() => route('/join')}>
                Join for $9 / year{' '}
              </Button>
            </div>
          </div>

          <div class="row">
            <div
              class="mt-5 mx-5 pt-4 px-4"
              style={{ boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 24px -2px' }}
            >
              <img class="img-fluid" src={screenshot} alt="Manter Screenshot" />
            </div>
          </div>
        </section>
        <section id="features" class="mt-5 py-5">
          <div class="row">
            <div class="col mx-auto" style={{ maxWidth: '400px' }}>
              <h4 class="mb-3 text-center">Own your data</h4>
              <p class="line-h-lg font-lg">
                Let's keep things between us. Your data will never be shared with anyone. Export and
                delete things whenever.
              </p>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col mx-auto" style={{ maxWidth: '400px' }}>
              <h4 class="mb-3 text-center">Plain and simple</h4>
              <p class="line-h-lg font-lg">
                No recommendations, sharing, liking or clapping. Manter prizes a clean, simple and
                lightweight design.
              </p>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col mx-auto" style={{ maxWidth: '400px' }}>
              <h4 class="mb-3 text-center">Sustainable model</h4>
              <p class="line-h-lg font-lg">
                By paying a few dollars a year, you help keeping Manter ad-free and support the
                development of new features.
              </p>
            </div>
          </div>
          {/* <div class="row mt-4">
            <div class="col text-center mx-auto" style={{ maxWidth: '400px' }}>
              <h4 class="mb-3">Fair model</h4>
              <p class="line-h-lg">

              </p>
            </div>
          </div> */}
        </section>
        <section id="roadmap">
          <div class="text-center py-5">
            <h4 class="font-weight-normal">
              Questions? Get in touch by{' '}
              <a class="text-muted" href="mailto:martinelliruan@gmail.com">
                <u>email</u>
              </a>{' '}
              or send a DM on{' '}
              <a class="text-muted" href="https://twitter.com/manterapp" target="_blank" rel="noopener">
                <u>twitter</u>
              </a>
              .
            </h4>
            <h4 class="mt-5 font-weight-normal">
              See the complete{' '}
              <a
                class="text-muted"
                href="https://trello.com/b/ENmnMrxm/manter-roadmap"
                target="_blank" rel="noopener"
              >
                <u>roadmap</u>
              </a>{' '}
              and vote for features.
            </h4>
          </div>
        </section>
        <section id="cta2">
          <div class="text-center py-5 mb-5">
            <Button style={ctaButton} class="d-block m-auto" onClick={() => route('/join')}>
              Join now
            </Button>
          </div>
        </section>
      </div>
    )
  }
}

export default connect(
  null,
  Landing,
)



// WEBPACK FOOTER //
// ./pages/Landing.js